export default __webpack_public_path__ + "_/_/_/packages/playbook-pwa-ui/src/assets/icons/konfiguratoren.svg";